// Source: app/scripts/controllers/auction.js
Auction.controller('AuctionController', [
  '$scope',
  '$filter',
  'Downloader',
  '$sce',
  '$modal',
  'toaster',
  '$location',
  'Auction',
  'AuctionParticipationRequest',
  function ($scope, $filter, Downloader, $sce, $modal, toaster, $location, Auction, AuctionParticipationRequest) {

    $scope.modalPublish = $modal({
      scope: $scope,
      template: 'forms/modals/publish_auction.html',
      show: false
    });
    $scope.modalClose = $modal({
      scope: $scope,
      template: 'forms/modals/close_auction_confirm.html',
      show: false
    });
    $scope.modalCancel = $modal({
      scope: $scope,
      template: 'forms/modals/cancel_auction_confirm.html',
      show: false
    });
    $scope.modalPostpone = $modal({
      scope: $scope,
      template: 'forms/modals/postpone_auction.html',
      show: false
    });
    $scope.modalDuplicate = $modal({
      scope: $scope,
      template: 'forms/modals/duplicate_auction.html',
      show: false
    });
    $scope.modalForceFinish = $modal({
      scope: $scope,
      template: 'forms/modals/force_finish_auction_confirm.html',
      show: false
    });
    $scope.modalSetLotPart = $modal({
      scope: $scope,
      template: 'forms/modals/set_lot_part.html',
      show: false
    });

    $scope.doPublishAuction = function () {
      Auction.publish({
        auctionNumber: $scope.publishEntity.auctionNumber
      }, function () {
        $scope.auctionCrud.clear();
        $scope.auctionCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("PUBLISHED"));
        $scope.modalPublish.hide();
      });
    };
    $scope.doCloseAuction = function () {
      Auction.close({
        auctionNumber: $scope.closeEntity.auctionNumber
      }, function () {
        $scope.auctionCrud.clear();
        $scope.auctionCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("CLOSED"));
        $scope.modalClose.hide();
      });
    };

    $scope.doCancelAuction = function () {
      Auction.cancel($scope.cancelEntity, function () {
        $scope.auctionCrud.clear();
        $scope.auctionCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("CANCELLED"));
        $scope.modalCancel.hide();
      });
    };

    $scope.doForceFinishAuction = function () {
      Auction.forceFinish($scope.forceFinishEntity, function () {
        $scope.auctionCrud.clear();
        $scope.auctionCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("FINISHED"));
        $scope.modalForceFinish.hide();
      });
    };




    $scope.postponeAuction = function() {
      Auction.postpone({
        auctionNumber: $scope.postponeEntity.auctionNumber,
        startDate: $scope.postponeEntity.startDate,
        endDate: $scope.postponeEntity.endDate,
        notes: $scope.postponeEntity.notes
      }, function() {
            $scope.auctionCrud.clear();
            $scope.auctionCrud.reload();
            toaster.pop('success', $filter('translate')('generic.success'),
              $filter('translate')("eauction.auction_postpone"));
            $scope.modalPostpone.hide();
      });
    };

    $scope.duplicateAuction = function() {
      Auction.duplicate({
        auctionNumber: $scope.duplicateEntity.auctionNumber,
        startDate: $scope.duplicateEntity.startDate,
        endDate: $scope.duplicateEntity.endDate
      }, function() {
            $scope.auctionCrud.clear();
            $scope.auctionCrud.reload();
            Auction.findDuplicates({
              code: $scope.duplicateEntity.auctionNumber
            }, function(data) {
                toaster.pop('success', $filter('translate')('generic.success'),
                  $filter('translate')("eauction.auction_duplicate") + " " + data);
            });
            $scope.modalDuplicate.hide();
      });
    };


    $scope.actions = [{
      text: 'eauction.publish_auction',
      name: 'publish_auction',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-bullhorn',
      enabled: false,
      onClick: function (entity) {
        $scope.publishEntity = entity;
        $scope.modalPublish.$promise.then($scope.modalPublish.show);
      }
    }, {
      text: 'eauction.preview_announcement',
      name: 'preview_announcement',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-file-word-o',
      enabled: false,
      onClick: function (entity) {
        Downloader.download('/data/rest/auctions/' + entity.id + '/pdf');
      }
    }, {
      text: 'CLOSE',
      name: 'close',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-minus-circle',
      enabled: false,
      onClick: function (entity) {
        $scope.closeEntity = entity;
        $scope.modalClose.$promise.then($scope.modalClose.show);
      }
    }, {
      text: 'eauction.auction_cancel',
      name: 'cancel',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-times',
      enabled: false,
      onClick: function (entity) {
        $scope.cancelEntity = entity;
        $scope.cancelUsers = AuctionParticipationRequest.findAuctionRequestUsers({
          auctionNumber: entity.auctionNumber
        });
        $scope.modalCancel.$promise.then($scope.modalCancel.show);
      }
    }, {
      text: 'eauction.republish',
      name: 'republish',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-bullhorn',
      enabled: false,
      onClick: function (entity) {
        $location.path("/admin/auctions/republish/" + entity.id);
      }
    }, {
      text: 'eauction.auction_postpone',
      name: 'postpone',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-clock-o',
      enabled: false,
      onClick: function (entity) {
        $scope.postponeEntity = {};
        $scope.postponeEntity.auctionNumber = entity.auctionNumber;
        $scope.postponeEntity.startDate = entity.startDate;
        $scope.postponeEntity.endDate = entity.endDate;
        $scope.modalPostpone.$promise.then($scope.modalPostpone.show);
      }
    }, {
      text: 'eauction.auction_duplicate',
      name: 'duplicate',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-files-o',
      enabled: false,
      onClick: function (entity) {
        $scope.duplicateEntity = {};
        $scope.duplicateEntity.auctionNumber = entity.auctionNumber;
        Auction.getFailedAuctionLots({
            id: entity.id
        }, function (data) {
            $scope.duplicateEntity.auctionLots = data;
        });
        $scope.modalDuplicate.$promise.then($scope.modalDuplicate.show);
      }
    }, {
      text: 'eauction.finished_auction_report',
      name: 'finished_auction_report',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-list-alt',
      enabled: false,
      onClick: function (entity) {
        $location.path("/admin/auctions/auction_report/" + entity.id);
      }
    }, {
      text: 'force_finish',
      name: 'force_finish',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-minus-circle',
      enabled: false,
      onClick: function (entity) {
        $scope.forceFinishEntity = entity;
        $scope.modalForceFinish.$promise.then($scope.modalForceFinish.show);
      }
    }, {
      text: 'eauction.get_end_of_auction_report',
      name: 'get_end_of_auction_report',
      position: 'right',
      classes: 'btn btn-primary btn-sm',
      iconClass: 'fa fa-fw fa-file-pdf-o',
      enabled: false,
      onClick: function (entity) {
        Downloader.download('/data/rest/auctions/end_of_auction/' + entity.id + '/' + $scope.$root.LANG  + '/' +'/pdf');
      }
    }];

    $scope.afterSave = function (crudScope, entity) {
      crudScope.edit(entity.id);
      crudScope.reload();
    };


    var reloadLots = function (entity) {
      Auction.getLots({
        id: entity.id
      }, function (data) {
        $scope.auctionCrud.auction = {};
        $scope.auctionCrud.auctionLots = data;
      });
    };


    $scope.onNew = function (auctionScope, entity) {
      entity.detail = {};
      auctionScope.auction = {};
      delete $scope.auctionCrud.log;
      delete $scope.auctionCrud.auctionLots;

    };


    $scope.loadDetails = function (crudScope, entity) {
      if ($scope.auctionCrud) {

        entity.detail = entity.detail || {};

        Auction.loadDetails({
          id: entity.id
        }, function (data) {
          if (data && data.id) {
            $scope.auctionCrud.entity.detail = data;
          } else {
            $scope.auctionCrud.entity.detail = {
              instruction: {
                valueEN: '',
                valueSQ: '',
                valueSR: ''
              }
            }
          }
          $scope.auctionCrud.entity.detail.auction = {id: entity.id};
        });

        crudScope.previousAnnouncements = Auction.getPreviousAnnouncement({
          id: entity.id
        });

        reloadLots(entity);
        crudScope.log = Auction.getLog({
          code: entity.auctionNumber
        });
      }
    };


    $scope.onAuctionCrudInit = function () {

      $scope.auctionCrud.downloadPreviousAnnouncement = function (id) {
        Downloader.download('/data/rest/attachments/' + id);
      };

      $scope.auctionCrud.tabs = [{
        idx: 0,
        name: 'info',
        active: true,
        disabled: function () {
          return false;
        }
      }, {
        idx: 1,
        name: 'description',
        active: false,
        disabled: function () {
          return !($scope.auctionCrud.entity && $scope.auctionCrud.entity.id);
        }
      }, {
        idx: 2,
        name: 'lots',
        active: false,
        disabled: function () {
          return !($scope.auctionCrud.entity && $scope.auctionCrud.entity.id);
        }
      }];
      $scope.auctionCrud.activeTab = $scope.auctionCrud.tabs[0];

      $scope.auctionCrud.selectTab = function (tab) {
        $scope.auctionCrud.activeTab.active = false;
        tab.active = true;
        $scope.auctionCrud.activeTab = $scope.auctionCrud.tabs[tab.idx];
      };

      $scope.auctionCrud.downloadAnnouncement = function (auction) {
        Auction.getAnnouncement({
          id: auction.id
        }, function (data) {
          if (data && data.id) {
            Downloader.download('/data/rest/attachments/' + data.id);
          } else {
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')("eauction.no_auction_anouncement"));
          }
        });
      };

      $scope.auctionCrud.auction = {};

      $scope.auctionCrud.afterLotComboInit = function (lotsComboScope) {
        $scope.auctionCrud.reloadLots = function () {
          lotsComboScope.reload();
        };
        lotsComboScope.reload();
      };
      $scope.auctionCrud.addLots = function () {
        var lots = $scope.auctionCrud.auction.lots;
        Auction.addLots({
          lots: lots,
          auctionNumber: $scope.auctionCrud.entity.auctionNumber
        }, function () {
          reloadLots($scope.auctionCrud.entity);
          $scope.auctionCrud.reloadLots();
        });
      };

      $scope.auctionCrud.removeLot = function (lot) {
        Auction.removeLot({
          auctionNumber: $scope.auctionCrud.entity.auctionNumber,
          lotCode: lot.code
        }, function () {
          reloadLots($scope.auctionCrud.entity);
          $scope.auctionCrud.reloadLots();
        });
      };

      $scope.auctionCrud.setLotPart = function (lot){
        $scope.lotPartEntity = {};
        $scope.lotPartEntity.auction = lot.auction;
        $scope.lotPartEntity.lot = lot;
        Auction.getLotPart({
          lotId: lot.id,
          auctionId: lot.auction.id
        }, function(data){
          console.log('data vo get lot part = ');
          console.log(data);
          $scope.lotPartEntity.part = data.partNumber;
          $scope.modalSetLotPart.$promise.then($scope.modalSetLotPart.show);
        });


      };



      $scope.setLotPartSave = function() {
        Auction.setLotPart({
          lotId: $scope.lotPartEntity.lot.id,
          auctionId: $scope.lotPartEntity.auction.id,
          lotPart: $scope.lotPartEntity.part
        }, function() {
          // $scope.auctionCrud.clear();
          // $scope.auctionCrud.reload();
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("eauction.lot_part_saved"));
          $scope.modalSetLotPart.hide();
        });
      };
    }


  }
]);


